import { addFormatApi, changeDefaultStatusApi, deleteFormatFromBranch, fetchBranchDetailsData, getAllLrFormateApi, getAllLrFormatebyBranch } from '_services/accountsServices/branchServices';
import { CommonInput, CommonTextarea, CommonToast, CrossButton, CustomSelect } from 'components';
import Tab from 'components/common/Tab';
import { constant } from 'constants/constant';
import { AppConfig } from 'lib';
import Loading from 'pages/Loading';
import React, { useContext, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast';
import { IoSettingsOutline } from 'react-icons/io5'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { RxDragHandleDots2 } from 'react-icons/rx';
import { useParams } from 'react-router-dom';
import { StorageServices } from 'utils';
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Format1, Format2, Format3, Format4, Format5, Format6, Format7 } from './LrFormat';
import { ConfirmModalFor } from 'modals';
import { Images } from 'constants';
import { UserContext } from 'context';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import Format9 from './LrFormat/Format9';

// ─── SortableItem must be OUTSIDE BranchLrFormat to prevent remount on every render ───
function SortableItem({ item, onToggleMain, onToggleSelect, onChangeColumnTitle, isFormat9 }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.name });
    const style = { transform: CSS.Transform.toString(transform), transition };

    return (
        <li ref={setNodeRef} style={style} className="__tabFields_item" {...attributes}>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '6px' }}>
                <span className="__tabFields_dragIcon" {...listeners} style={{ flexShrink: 0, cursor: 'grab', display: 'flex', alignItems: 'center' }}>
                    <RxDragHandleDots2 />
                </span>

                <input
                    type="checkbox"
                    id={item.name}
                    name="LR_Details"
                    checked={item.check}
                    disabled={isFormat9}
                    onChange={() => !isFormat9 && onToggleMain(item.name)}
                    style={{ flexShrink: 0, ...(isFormat9 ? { cursor: 'not-allowed', opacity: 0.5 } : {}) }}
                />

                {isFormat9 ? (
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <input
                            type="text"
                            className="anvLabel __col_title_input"
                            value={item.label ?? item.name}
                            maxLength={50}
                            onChange={e => onChangeColumnTitle(item.name, e.target.value)}
                            style={{
                                width: '100%',
                                border: 'none',
                                borderBottom: item.labelError ? '1px solid #e74c3c' : '1px solid #ccc',
                                outline: 'none',
                                background: 'transparent',
                                fontSize: 'inherit',
                                padding: '2px 4px',
                                boxSizing: 'border-box',
                                lineHeight: '1.4',
                            }}
                        />
                        {item.labelError && (
                            <span style={{ fontSize: '10px', color: '#e74c3c', display: 'block', marginTop: '2px' }}>
                                Min. 3 characters required
                            </span>
                        )}
                    </div>
                ) : (
                    <label htmlFor={item.name} className="anvLabel" style={{ flex: 1, margin: 0 }}>
                        {item.name}
                    </label>
                )}
            </div>

            {!isFormat9 && Array.isArray(item.select) && item.check && (
                <div className="__tabFields_select">
                    {item.select.map((opt, index) => (
                        <div key={index} className="__tabFields_select_item">
                            <input
                                type="checkbox"
                                id={`${item.name}_${opt.name}`}
                                name={`${item.name}_select`}
                                checked={opt.check}
                                onChange={() => onToggleSelect(item.name, opt.name)}
                            />
                            <label htmlFor={`${item.name}_${opt.name}`}>{opt.name}</label>
                        </div>
                    ))}
                </div>
            )}
        </li>
    );
}

const BranchLrFormat = ({ onDataFetch }) => {
    let { id } = useParams();
    const BASE_URL = AppConfig.api_baseurl;
    const [showAddNewFormat, setShowAddNewFormat] = useState(false);
    const [showLrSetting, setShowLrSetting] = useState(false);
    const [formatList, setFormatList] = useState([]);
    const [branchLrFormate, setBranchLrFormate] = useState([]);
    const [isLrLoading, setIsLrLoading] = useState(false);
    const [isLrBranchLoading, setIsLrBranchLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [loadingId, setLoadingId] = useState(null);
    const companyId = StorageServices.getCompanyId();
    const [isSelected, setIsSelected] = useState([]);
    const [activeTab, setActiveTab] = useState(1);
    const [form, setForm] = useState("")
    const hasFetchedOnce = useRef(false);
    const [deleteLoadding, setDeleteLoadding] = useState(false)
    const [confirmModalShow, setConfirmModalShow] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState(null);
    const hasSetDefaultRef = useRef(false);
    const [detailsData, setDetailsData] = useState({})
    const { masterData } = useContext(UserContext)

    const tabProps = {
        tabList: constant.lrSettingFormatTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab: activeTab
    }

    const FormatList = {
        1: <Format1 modifyForm={form} />,
        2: <Format2 modifyForm={form} />,
        3: <Format3 modifyForm={form} />,
        4: <Format4 modifyForm={form} />,
        5: <Format5 modifyForm={form} />,
        6: <Format6 modifyForm={form} />,
        7: <Format7 modifyForm={form} />,
        9: <Format9 modifyForm={form} />,
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5,
            },
        })
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over) return;
        if (active.id !== over.id) {
            const oldIndex = form.lr_table.findIndex((i) => i.name === active.id);
            const newIndex = form.lr_table.findIndex((i) => i.name === over.id);
            if (oldIndex !== -1 && newIndex !== -1) {
                const newItems = arrayMove(form.lr_table, oldIndex, newIndex);
                setForm((prev) => ({ ...prev, lr_table: newItems }));
            }
        }
    };

    useEffect(() => {
        if (!showAddNewFormat) {
            getBranchLrFormat(companyId, id)
        }
    }, [])

    useEffect(() => {
        if (id) {
            getBranchLrFormat(companyId, id)
        }
    }, [id])

    useEffect(() => {
        if (showAddNewFormat) {
            getAllLrFormate(companyId)
        }
    }, [showAddNewFormat])

    useEffect(() => {
        if (hasSetDefaultRef.current && isSelected.length === 1) {
            hasSetDefaultRef.current = false;
            changeDefaultStatus(1, isSelected[0]?._id);
        }
    }, [isSelected]);

    const getDataBranchDetails = async (id_1, id_2) => {
        try {
            let object = { branch_id: id_1, company_id: id_2 }
            const res = await fetchBranchDetailsData(object);
            if (res?.responseCode == 200) {
                setDetailsData(res?.data?.branch)
                onDataFetch(res?.data?.branch)
            }
        } catch (error) { }
    }

    useEffect(() => {
        if (id) {
            getDataBranchDetails(id, companyId);
        }
    }, [id, masterData])

    const handleAddNewFormatClick = () => setShowAddNewFormat(true);
    const handleSettingsClick = () => setShowLrSetting(true);

    const handleDeleteClick = (event, item) => {
        event.stopPropagation()
        setConfirmModalShow(item);
    }

    const getBranchLrFormat = async (company_id, branch_id) => {
        const payload = { company_id, branch_id }
        try {
            if (!hasFetchedOnce.current) {
                setIsLrBranchLoading(true);
            }
            const res = await getAllLrFormatebyBranch(payload)
            if (res?.responseCode == 200) {
                setBranchLrFormate(res?.data?.formats)
                const formatPromises = res?.data?.formats?.map(async (rf) => {
                    const response = await fetch(`${BASE_URL}${rf.template_img}`);
                    const blob = await response.blob();
                    const blobUrl = URL.createObjectURL(blob);
                    return { ...rf, imageUrl: blobUrl };
                });
                const ModifyFormate = await Promise.all(formatPromises);
                setBranchLrFormate(ModifyFormate);
                setIsSelected(res?.data?.formats);
            }
        } catch (error) {
        } finally {
            setIsLrBranchLoading(false);
            hasFetchedOnce.current = true;
        }
    }

    const getAllLrFormate = async (company_id) => {
        const payload = { company_id };
        setIsLrLoading(true);
        try {
            const res = await getAllLrFormateApi(payload);
            if (res?.responseCode === 200) {
                const formatPromises = res?.data?.formats?.map(async (rf) => {
                    const response = await fetch(`${BASE_URL}${rf.template_img}`);
                    const blob = await response.blob();
                    const blobUrl = URL.createObjectURL(blob);
                    return { ...rf, imageUrl: blobUrl };
                });
                const ModifyFormate = await Promise.all(formatPromises);
                setFormatList(ModifyFormate);
            }
        } catch (error) {
            console.error("Failed to load LR formats", error);
        } finally {
            setIsLrLoading(false);
        }
    };

    const handleAddFormate = async (frDetails) => {
        const frDetailsWithoutImage = { ...frDetails };
        delete frDetailsWithoutImage.imageUrl;
        const payload = { company_id: companyId, branch_id: id, format: frDetailsWithoutImage }
        setLoadingId(frDetails.id);
        try {
            const res = await addFormatApi(payload)
            if (res?.responseCode === 200) {
                toast.success(res?.responseMessage || "Add Successfully")
                const updatedFormats = [...isSelected, payload.format];
                setIsSelected(updatedFormats);
                if (updatedFormats.length === 1) {
                    hasSetDefaultRef.current = true;
                    changeDefaultStatus(1, updatedFormats[0]?.format?._id);
                }
                getBranchLrFormat(companyId, id)
            } else {
                CommonToast(res?.responseMessage)
            }
        } catch (error) { }
        setLoadingId(null);
    }

    const onToggleMain = (name) => {
        setForm(prev => ({
            ...prev,
            lr_table: prev.lr_table.map(field => {
                if (field.name !== name) return field;
                const newValue = !field.check;
                return {
                    ...field,
                    check: newValue,
                    select: Array.isArray(field.select)
                        ? field.select.map(opt => ({ ...opt, check: newValue ? opt.check : false }))
                        : field.select
                };
            })
        }));
    };

    const onToggleSelect = (parentName, optionName) => {
        setForm(prev => ({
            ...prev,
            lr_table: prev.lr_table.map(field => {
                if (field.name !== parentName) return field;
                const updatedSelect = field.select.map(opt =>
                    opt.name === optionName ? { ...opt, check: !opt.check } : opt
                );
                const anyChildChecked = updatedSelect.some(opt => opt.check);
                return { ...field, check: anyChildChecked || field.check, select: updatedSelect };
            })
        }));
    };

    // ─── New: update column label for Format 9 ───────────────────────────────
    const onChangeColumnTitle = (name, newTitle) => {
        setForm(prev => ({
            ...prev,
            lr_table: prev.lr_table.map(field =>
                field.name === name
                    ? { ...field, label: newTitle, labelError: newTitle.trim().length > 0 && newTitle.trim().length < 3 }
                    : field
            )
        }));
    };

    const handleDelete = async () => {
        const payload = { company_id: companyId, branch_id: id, format_id: confirmModalShow?._id }
        setDeleteLoadding(true)
        try {
            const res = await deleteFormatFromBranch(payload)
            if (res?.responseCode == 200) {
                setDeleteLoadding(false)
                toast.success(res.responseMessage)
                setConfirmModalShow(false)
                getBranchLrFormat(companyId, id)
            } else {
                setDeleteLoadding(false)
            }
        } catch (error) {
            setDeleteLoadding(false)
        }
    }

    const handleUpdate = async () => {
        if (form.id === 9 || form.id === 3) {
            const hasError = form?.lr_table?.some(f => {
                const val = (f.label ?? f.name ?? '').trim();
                return val.length < 3;
            });
            if (hasError) {
                setForm(prev => ({
                    ...prev,
                    lr_table: prev.lr_table.map(f => ({
                        ...f,
                        labelError: (f.label ?? f.name ?? '').trim().length < 3
                    }))
                }));
                toast.error("All column titles must be at least 3 characters.");
                return;
            }
        }

        const frDetailsWithoutImage = { ...form };
        delete frDetailsWithoutImage.imageUrl;

        if (frDetailsWithoutImage.id === 9 || frDetailsWithoutImage.id === 3) {
            frDetailsWithoutImage.lr_table = frDetailsWithoutImage.lr_table?.map(
                ({ label, labelError, _stableId, _titleError, name, ...rest }) => ({
                    ...rest,
                    name: label ?? name,
                })
            );
        }

        const payload = { company_id: companyId, branch_id: id, format: frDetailsWithoutImage };
        try {
            setIsUpdateLoading(true);
            const res = await addFormatApi(payload);
            if (res?.responseCode === 200) {
                toast.success(res?.responseMessage || "Add Successfully");
                setIsUpdateLoading(false);
                setShowLrSetting(false);
                getBranchLrFormat(companyId, id);
            } else {
                setIsUpdateLoading(false);
            }
        } catch (error) {
            setIsUpdateLoading(false);
        }
    };

    const handleChangeDefaultStatus = (event, formatId, index) => {
        const checkedValue = event.target.checked == true ? 1 : 0
        if (formatId) changeDefaultStatus(checkedValue, formatId)
    }

    const changeDefaultStatus = async (checkedValue, formatId) => {
        const payload = { company_id: companyId, branch_id: id, format_id: formatId, is_default: checkedValue };
        try {
            const res = await changeDefaultStatusApi(payload);
            if (res?.responseCode !== 200) {
                toast?.error(res?.responseMessage || "Failed to update status.");
            }
            getBranchLrFormat(companyId, id);
        } catch (error) {
            toast?.error(error?.message || "Something went wrong.");
            getBranchLrFormat(companyId, id);
        }
    };

    let confirmModalProps = {
        show: confirmModalShow,
        closeModal: (e) => setConfirmModalShow(false),
        title: "Confirm",
        submitTitle: "Delete",
        onSubmit: handleDelete,
        confirmModal: "confirmModal",
        icon: Images.DELETEICON.default,
        isLoadding: deleteLoadding,
        disabled: deleteLoadding
    };



    return (
        <>
            <div className='__setBr_main'>
                <div className='__setf_brancOtr'>
                    <div className='__layOutFr'>
                        <div className='__layOutFr_head'>
                            <h4>LR Formats</h4>
                            <button onClick={() => handleAddNewFormatClick(false)}>Add New Format</button>
                        </div>

                        <div className='__layOutFr_body' style={{ flex: "1", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div className='__inrFormate_main' style={{ position: "relative", height: "100%", width: "100%" }}>
                                <div className='__frmInner_fx'>
                                    {isLrBranchLoading && (
                                        <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}>
                                            <Loading />
                                        </div>
                                    )}
                                    {!isLrBranchLoading && (
                                        <>
                                            {branchLrFormate?.map((br, index) => (
                                                <div className='__frmOtr_cover' key={br?.id}
                                                    onClick={() => { handleSettingsClick(br); setForm(br); }}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <div className='__frm_coverInr'>
                                                        <div className='__frm_container position-relative' style={{ minHeight: '200px' }}>
                                                            <img src={br?.imageUrl} alt={br.name} style={{ width: '100%' }} />
                                                        </div>
                                                        <div className='__frm_setting_sd'>
                                                            <div className="__frm_switcher" onClick={(e) => e.stopPropagation()}>
                                                                <div className="anvSwitch_frm form-check form-switch" bis_skin_checked="1">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        role="switch"
                                                                        id={`makeDefault${index}`}
                                                                        name="makeDefault"
                                                                        autoComplete="off"
                                                                        checked={br?.is_default}
                                                                        disabled={br?.is_default}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onChange={(event) => {
                                                                            const checked = event.target.checked ? 1 : 0;
                                                                            setBranchLrFormate(prev =>
                                                                                prev.map((item, i) => ({
                                                                                    ...item,
                                                                                    is_default: i === index && checked ? 1 : 0,
                                                                                }))
                                                                            );
                                                                            if (checked) handleChangeDefaultStatus(event, br?._id, index);
                                                                        }}
                                                                    />
                                                                    <label htmlFor={`makeDefault${index}`} onClick={(e) => e.stopPropagation()}>Default</label>
                                                                </div>
                                                            </div>
                                                            <div className='_frm_btns'>
                                                                <button className='_delete_lrForm_btn' onClick={(event) => handleDeleteClick(event, br)}>
                                                                    <RiDeleteBin6Line />
                                                                </button>
                                                                <button className='_edit_lrForm_btn' onClick={() => { handleSettingsClick(br); setForm(br); }}>
                                                                    <IoSettingsOutline />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p className="_frm_txt">{br?.name}</p>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add New LR Format Offcanvas */}
            <div
                className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showAddNewFormat ? "show" : ""}`}
                tabIndex={-1}
                style={{ visibility: showAddNewFormat ? "visible" : "hidden" }}
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title">Add LR Format</h5>
                    <CrossButton type="button" className="_switchBtn __animEffect_btn" onClick={() => setShowAddNewFormat(false)} style={{ marginLeft: 'auto' }}>
                        <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z" fill="black" />
                        </svg>
                    </CrossButton>
                </div>

                <div className="offcanvas-body" style={{ height: 'calc(100vh - 109px)' }}>
                    <div className='__layOutFr_body' style={{ height: isLrLoading ? '100%' : 'auto' }}>
                        <div className='__inrFormate_main' style={{ position: "relative", height: isLrLoading ? '100%' : 'auto' }}>
                            <div className='__frmInner_fx'>
                                {isLrLoading && (
                                    <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}>
                                        <Loading />
                                    </div>
                                )}
                                {!isLrLoading && (
                                    <>
                                        {formatList?.map((fr) => {
                                            const isAdded = isSelected.some(f => f.id === fr.id);
                                            const isLoading = loadingId === fr.id;
                                            return (
                                                <div className='__frmOtr_cover' key={fr?.id}>
                                                    <div className='__frm_coverInr'>
                                                        <div className='__frm_container position-relative' style={{ minHeight: '200px', cursor: 'pointer' }} onClick={() => setSelectedFormat(fr)}>
                                                            <img src={fr?.imageUrl} alt={fr.name} style={{ width: '100%' }} />
                                                        </div>
                                                        <div className='__frm_setting_sd'>
                                                            <button
                                                                className='_add_lrForm_btn'
                                                                style={{
                                                                    backgroundColor: isAdded ? '#ccc' : 'rgba(0, 21, 60, 1)',
                                                                    color: isAdded ? '#666' : '#fff',
                                                                    cursor: isAdded ? 'not-allowed' : 'pointer',
                                                                    border: 'none',
                                                                    padding: '8px 16px',
                                                                    transition: 'background-color 0.3s',
                                                                }}
                                                                disabled={isAdded || isLoading}
                                                                onClick={() => handleAddFormate(fr)}
                                                            >
                                                                {isLoading ? 'Adding...' : (isAdded ? 'Added' : 'Add Format')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <p className="_frm_txt">{fr?.name}</p>
                                                </div>
                                            );
                                        })}
                                    </>
                                )}

                                {selectedFormat && (
                                    <div className="__preView_modal">
                                        <div className='__preView_modal_content'>
                                            <div className='__preView_modal_header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <p style={{ fontWeight: 'bold' }}>{selectedFormat?.name}</p>
                                                <button onClick={() => setSelectedFormat(null)} style={{ background: 'transparent', border: 'none', fontSize: '20px', cursor: 'pointer' }}>
                                                    <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                        <path d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z" fill="black" />
                                                    </svg>
                                                </button>
                                            </div>
                                            <div style={{ padding: '20px' }}>
                                                <img src={selectedFormat?.imageUrl} alt={selectedFormat?.name} style={{ width: '100%', height: 'auto' }} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Backdrop */}
            <div className={showAddNewFormat ? "offBack_drop" : ""}></div>

            {/* LR Setting Offcanvas */}
            {form?.name && (
                <div
                    className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showLrSetting ? "show" : ""}`}
                    tabIndex={-1}
                    style={{ visibility: showLrSetting ? "visible" : "hidden" }}
                >
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title">LR Settings</h5>
                        <CrossButton type="button" className="_switchBtn __animEffect_btn" onClick={() => setShowLrSetting(false)} style={{ marginLeft: 'auto' }}>
                            <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                <path d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z" fill="black" />
                            </svg>
                        </CrossButton>
                    </div>

                    <div className="offcanvas-body" style={{ height: 'calc(100vh - 109px)' }}>
                        <div className='__frm_setting_cover'>
                            <div className="__frm_container">
                                {FormatList[form.id]}
                            </div>

                            <div className='__frm_settFlx'>
                                <div className='__frm_settInr'>
                                    <div className='addPr_flBx'>
                                        <Tab {...tabProps} />

                                        {activeTab === 1 && (
                                            <div className='__frmSet_tabContent'>
                                                <div>
                                                    <h6>Address Details</h6>
                                                    <div className='__template_type mb-4'>
                                                        {['Company', 'Branch'].map((option) => (
                                                            <div className="_dualCheckr_bx" key={option}>
                                                                <input
                                                                    className="form-check-input"
                                                                    id={option}
                                                                    type="radio"
                                                                    name="address"
                                                                    value={option?.toLowerCase()}
                                                                    checked={(form?.address)?.toLowerCase() === option?.toLowerCase()}
                                                                    onChange={handleChange}
                                                                />
                                                                <label htmlFor={option} className="form-check-label">{option}</label>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {form.id !== 3 && form.id !== 9 && (
                                                        <div className='mb-4'>
                                                            <CommonInput
                                                                type="text"
                                                                label="Item Description"
                                                                name="item_desc"
                                                                value={form.item_desc}
                                                                placeholder="Item Description"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    )}

                                                    <div className='mb-4'>
                                                        <CommonTextarea
                                                            type="text"
                                                            label="Terms & Conditions"
                                                            name="terms_conds"
                                                            value={form.terms_conds}
                                                            placeholder="Terms & Conditions"
                                                            rows="4"
                                                            onChange={handleChange}
                                                            maxLength={180}
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <h6>LR Details</h6>
                                                    <DndContext
                                                        sensors={sensors}
                                                        collisionDetection={closestCenter}
                                                        onDragEnd={handleDragEnd}
                                                        modifiers={[restrictToVerticalAxis]}
                                                    >
                                                        <SortableContext
                                                            items={form?.lr_table == null ? [] : form?.lr_table?.map(i => i?.name)}
                                                            strategy={verticalListSortingStrategy}
                                                        >
                                                            <ul className="__tabFields_bx">
                                                                {form?.lr_table?.map(item => (
                                                                    <SortableItem
                                                                        key={item.name}
                                                                        item={item}
                                                                        onToggleMain={onToggleMain}
                                                                        onToggleSelect={onToggleSelect}
                                                                        onChangeColumnTitle={onChangeColumnTitle}
                                                                        isFormat9={form.id === 9 || form.id === 3}  // यहाँ change
                                                                    />
                                                                ))}
                                                            </ul>
                                                        </SortableContext>
                                                    </DndContext>
                                                </div>
                                            </div>
                                        )}

                                        {activeTab === 2 && (
                                            <div className='__frmSet_tabContent'>
                                                {form?.copies?.map((i, index) => {
                                                    const otherCopiesSelected = form.copies.some((copy, idx) => idx !== 0 && copy.check);
                                                    const isOriginal = index === 0;
                                                    const shouldBeChecked = isOriginal ? (otherCopiesSelected ? i.check : true) : i.check;
                                                    const shouldBeDisabled = isOriginal && !otherCopiesSelected;

                                                    return (
                                                        <div className='__copy_type mb-3' key={index}>
                                                            <input
                                                                type="checkbox"
                                                                name="LR_Details"
                                                                id={`copy_${index}`}
                                                                checked={shouldBeChecked}
                                                                disabled={shouldBeDisabled}
                                                                onChange={() => {
                                                                    const updatedCopies = form.copies.map((c, i) => {
                                                                        if (i === index) {
                                                                            if (isOriginal && !otherCopiesSelected) return c;
                                                                            return { ...c, check: !c.check };
                                                                        }
                                                                        if (i === 0 && !isOriginal) {
                                                                            const willHaveOtherSelected = form.copies.some((copy, idx) =>
                                                                                idx !== 0 && idx !== index && copy.check
                                                                            );
                                                                            if (!willHaveOtherSelected && form.copies[index].check) {
                                                                                return { ...c, check: true };
                                                                            }
                                                                        }
                                                                        return c;
                                                                    });
                                                                    setForm({ ...form, copies: updatedCopies });
                                                                }}
                                                            />
                                                            <label htmlFor={`copy_${index}`} className="anvLabel">{i?.name}</label>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="offcanvas-footer">
                                    <button className="_addComm_btn" onClick={handleUpdate} disabled={isUpdateLoading}>
                                        {isUpdateLoading ? "Updating..." : "Update"}
                                    </button>
                                    <button className="_cancel_btn" onClick={() => setShowLrSetting(false)}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Backdrop */}
            {form?.name && <div className={showLrSetting ? "offBack_drop" : ""}></div>}

            {confirmModalShow && (
                <ConfirmModalFor {...confirmModalProps}>
                    <p className="_confirmPrx">Are you sure you want to delete {confirmModalShow?.name}</p>
                </ConfirmModalFor>
            )}
        </>
    )
}

export default BranchLrFormat